import React, { useState } from "react";
import { Truck, LockKeyhole, Mail } from "lucide-react";
import { useAuth } from "../lib/auth";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";

export default function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const nav = useNavigate();
  const loc = useLocation();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.name}`);
      const to = loc.state?.from?.pathname;
      nav(to || (user.role === "CEO" ? "/ceo" : "/manager"), { replace: true });
    } catch (e) {
      setErr(e.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const quick = (e, p) => { setEmail(e); setPassword(p); };

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-slate-100 flex items-center justify-center p-5 lf-grain">
      <div className="w-full max-w-md animate-fade-in">
        <div className="bg-white rounded-2xl shadow-xl border border-border p-8">
          <div className="flex flex-col items-center mb-7">
            <div className="w-16 h-16 rounded-2xl bg-primary text-primary-foreground flex items-center justify-center mb-4 shadow-md">
              <Truck size={32} strokeWidth={2.4} />
            </div>
            <h1 className="font-display text-3xl font-bold">LedgerFlow</h1>
            <p className="text-sm text-muted-foreground mt-1">Logistics Staffing &amp; Payroll System</p>
          </div>

          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <label className="text-sm font-semibold mb-1.5 block">Email</label>
              <div className="relative">
                <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
                <input
                  data-testid="login-email-input"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@company.com"
                  className="w-full pl-9 pr-3 py-2.5 rounded-lg border border-input bg-white focus:outline-none focus:ring-2 focus:ring-primary/40 focus:border-primary"
                />
              </div>
            </div>
            <div>
              <label className="text-sm font-semibold mb-1.5 block">Password</label>
              <div className="relative">
                <LockKeyhole size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
                <input
                  data-testid="login-password-input"
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  className="w-full pl-9 pr-3 py-2.5 rounded-lg border border-input bg-white focus:outline-none focus:ring-2 focus:ring-primary/40 focus:border-primary"
                />
              </div>
            </div>

            {err ? (
              <div data-testid="login-error" className="text-sm text-destructive bg-destructive/10 border border-destructive/20 rounded-lg p-2.5">
                {err}
              </div>
            ) : null}

            <button
              data-testid="login-submit-button"
              type="submit"
              disabled={loading}
              className="w-full py-3 rounded-lg bg-primary text-primary-foreground font-semibold hover:brightness-110 transition active:scale-[0.99] disabled:opacity-70"
            >
              {loading ? "Signing in..." : "Sign In"}
            </button>
          </form>

          {/* <div className="mt-6 border-t border-border pt-4">
            <div className="text-xs text-muted-foreground mb-2">Quick demo access:</div>
            <div className="flex gap-2">
              <button
                type="button"
                data-testid="demo-ceo-btn"
                onClick={() => quick("ceo@ledgerflow.com", "Ceo@12345")}
                className="flex-1 text-xs py-2 rounded-lg border border-border bg-white hover:bg-secondary transition"
              >
                CEO Admin
              </button>
              <button
                type="button"
                data-testid="demo-manager-btn"
                onClick={() => quick("manager@ledgerflow.com", "Manager@12345")}
                className="flex-1 text-xs py-2 rounded-lg border border-border bg-white hover:bg-secondary transition"
              >
                Manager
              </button>
            </div>
          </div> */}
        </div>
        <div className="text-center text-xs text-muted-foreground mt-4">
          Installable PWA · Offline-ready · Mobile-first
        </div>
      </div>
    </div>
  );
}
